import React from 'react'
import { Text } from 'grommet'

const ErrorText = ({ children, ...props }) => <Text size="small" color="status-critical" {...props}>{children}</Text>

export default ErrorText